import { createFileRoute } from '@tanstack/react-router'
import { TestCallerIdsPage } from '@/features/admin/test-caller-ids'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/test-caller-ids/')({
  component: TestCallerIdsPage,
  beforeLoad: requireRole(['admin']),
})
